import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable } from 'rxjs';
import { HtmlPreviewDialogComponent } from '../dialogs/html-preview-dialog.component';
import { TextareaDialogComponent } from '../dialogs/textarea-dialog.component';
import { WidgetConfirmDialogComponent } from '../dialogs/widget-confirm-dialog.component';
import { DocumentInfo, DownloadResponse } from '@pt/pt-models';
import { HelpTooltipDialogComponent } from '@pt/dialog';
import { DocumentHistoryDialogComponent } from '../dialogs/document-history-dialog.component';
import { CommentDialogComponent } from '../dialogs/comment-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class WidgetDialogService {

  constructor(private modalService: NgbModal) {
  }

  runHistoryDialog = (docInfo: DocumentInfo) => {
    const modalRef = this.modalService.open(DocumentHistoryDialogComponent,
      {
        backdrop: 'static',
        size: 'xl',
        keyboard: true,
        centered: true
      });
    const duration = 1000 * 60 * 60 * 24 * 30;
    const fromTimestamp = Date.now() - duration;
    modalRef.componentInstance.loadEvents(docInfo, fromTimestamp, duration);
    return from(modalRef.result);
  };

  runPdfPreview = (title: Observable<string>, pdf: DownloadResponse) => {
    const modalRef = this.modalService.open(HtmlPreviewDialogComponent,
      {
        backdrop: 'static',
        size: 'full',
        keyboard: true
      });
    modalRef.componentInstance.run(title, pdf);
    return from(modalRef.result);
  };

  runTextArea = (title: Observable<string>, value: string, editable: boolean, description?: Observable<string>) => {
    const modalRef = this.modalService.open(TextareaDialogComponent,
      {
        backdrop: 'static',
        size: 'lg',
        keyboard: true,
        centered: true
      });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.value = value;
    modalRef.componentInstance.editable = editable;
    modalRef.componentInstance.description = description;
    return from(modalRef.result);
  };

  runComment = (title: Observable<string>, value: string, editable: boolean, description?: Observable<string>) => {
    const modalRef = this.modalService.open(CommentDialogComponent,
      {
        backdrop: 'static',
        size: 'lg',
        keyboard: true,
        centered: true
      });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.value = value;
    modalRef.componentInstance.editable = editable;
    modalRef.componentInstance.description = description;
    return from(modalRef.result);
  };

  runConfirmDialog = (title: string, message: string, info?: string) => {
    const modalRef = this.modalService.open(WidgetConfirmDialogComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: true,
      centered: true
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.info = info;

    return from(modalRef.result);
  };

  runWidgetHelpDialog = (title: Observable<string>, value: string) => {
    const modalRef = this.modalService.open(HelpTooltipDialogComponent,
      {
        // backdrop: 'static',
        size: 'lg',
        keyboard: true,
        centered: true
      });
    modalRef.componentInstance.run(title, value);
    return from(modalRef.result);
  };
}
